/**
 * Client-side semver helpers aligned with api ModuleVersionService numbering.
 * Replace-version approval renumbers the draft to the next minor of the source.
 */

const parseVersionParts = (version: string): number[] => (
  version.trim().replace(/^v/i, '').split('.').map((part) => Number.parseInt(part, 10) || 0)
);

/** Numeric `major.minor` comparison, so 10.0 sorts after 9.1. */
export const compareModuleVersions = (a: string, b: string): number => {
  const left = parseVersionParts(a);
  const right = parseVersionParts(b);
  const length = Math.max(left.length, right.length);
  for (let index = 0; index < length; index += 1) {
    const diff = (left[index] ?? 0) - (right[index] ?? 0);
    if (diff !== 0) return diff;
  }
  return 0;
};

export const getNextMinorVersion = (version: string): string => {
  const trimmed = version.trim();
  const [majorPart, minorPart = '0'] = trimmed.split('.');
  const major = Number.parseInt(majorPart, 10);
  const minor = Number.parseInt(minorPart, 10);
  if (Number.isNaN(major) || Number.isNaN(minor)) {
    return trimmed;
  }
  return `${major}.${minor + 1}`;
};
